import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const MainChartLegendContainer = styled.div`
  display: flex;
  margin-bottom: 30px;
  justify-content: center;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    justify-content: end;
  }
`;

export const MainChartLegendButtonGroupHolder = styled.div`
  > * {
    border-radius: 8px 0 0 8px;

    &:first-child {
      border-radius: 8px 0 0 8px;
    }

    &:last-child {
      border-radius: 0 8px 8px 0;
    }
  }
`;
